// Shopify injects recommendation HTML after page load. Re-run only the explicitly
// marked, guarded card initializers; native innerHTML does not execute scripts.
(() => {
  if (window.__fc3RelatedRuntime) return;
  window.__fc3RelatedRuntime = true;
  const initialized = new WeakSet();
  let scheduled = false;
  const hydrate = () => {
    scheduled = false;
    let changed = false;
    document.querySelectorAll('[data-fc3-related] script[data-fc-card-runtime]').forEach(source => {
      if (initialized.has(source)) return;
      initialized.add(source);
      changed = true;
      const script = document.createElement('script');
      if (source.nonce) script.nonce = source.nonce;
      script.textContent = source.textContent;
      document.head.appendChild(script);
      script.remove();
    });
    if (changed && typeof window.__ccCardRefresh === 'function') window.__ccCardRefresh();
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(hydrate);
  };
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (
        node.matches('[data-fc3-related], script[data-fc-card-runtime]') ||
        node.querySelector('[data-fc3-related], script[data-fc-card-runtime]')
      )
    ))) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
